import { render, staticRenderFns } from "./SearchRules.vue?vue&type=template&id=45670b95&scoped=true"
import script from "./SearchRules.vue?vue&type=script&lang=js"
export * from "./SearchRules.vue?vue&type=script&lang=js"
import style0 from "./SearchRules.vue?vue&type=style&index=0&id=45670b95&prod&scoped=true&lang=scss"
import style1 from "./SearchRules.vue?vue&type=style&index=1&id=45670b95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45670b95",
  null
  
)

export default component.exports